// extracted by mini-css-extract-plugin
export var root = "L_vZ";
export var wrapper = "L_v0";
export var image = "L_v1 d_w d_y d_W";
export var imageWithHeight = "L_v2";
export var crop = "L_v3";
export var round = "L_v4";
export var fixedHeight = "L_v5";